import EmpresasTablaActions from "@/pages/Clientes/Empresas/Tabla/EmpresasTablaActions";

export default {
  components: {
    EmpresasTablaActions,
  },
  beforeMount() {
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
    };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
    };
  },
  data: () => ({
    gridOptions: null,
    columnDefs: [
      {
        headerName: "id",
        field: "id_empresa",
        filter: false,
        sort: "asc",
        comparator: (a, b) => {
          const numA = parseInt(a);
          const numB = parseInt(b);
          return numA - numB;
        },
      },
      {
        headerName: "Razon Social",
        field: "RazonSocial",
      },
      {
        headerName: "CUIT",
        field: "CUIT",
      },
      {
        headerName: "Condicion IVA",
        field: "CondicionFrenteAlIVA",
      },
      {
        headerName: "Alicuota",
        field: "AlicuotaIVA",
      },
      {
        headerName: "DomicilioComercial",
        field: "DomicilioComercial",
      },
      {
        headerName: "Actions",
        cellRendererFramework: EmpresasTablaActions,
      },
    ],
    defaultColDef: null,
    api: null,
    columnApi: null,
  }),
  methods: {
    onGridReady({ api, columnApi }) {
      this.api = api;
      this.columnApi = columnApi;
      this.getEmpresas();
    },
    async getEmpresas() {
      this.api.showLoadingOverlay();

      await this.$store
        .dispatch("Empresas/getEmpresas", this.clienteId)
        .then((resp) => {
          if (!resp.ok) {
            this.$msgBoxOk(resp.message);
          }
        });
      this.api.hideOverlay();
      this.autoSizeAll(false);
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.columnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
  },
  computed: {
    rowData() {
      return this.$store.state.Empresas.empresas;
    },
  },
};
